module.exports = __webpack_public_path__ + "static/media/modalBuddies@3x.89beb031.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/modalBuddies@3x.png
// module id = 1892
// module chunks = 0